import React, { useState, useEffect } from "react";
import "./ForInfluencersVideo.scss";
import IntroVideo from "assets/video/intro.mp4";
import IntroPreview from "assets/images/ForInfluencersPage/Cards/intro_preview.png";
import GameProcess from "assets/video/game_process.mp4";
import GameProcessPreview from "assets/images/ForInfluencersPage/Cards/game_process_preview.png";
import PlayIcon from "assets/images/ForInfluencersPage/Cards/play.svg";
import DownloadBtn from "../../DownloadBtn";
import CrossIcon from 'assets/images/ForInfluencersPage/cross-icon.svg';

type VideoCard = {
    id: number;
    title: string;
    src: string;
    image: string;
};

export const ForInfluencersVideo: React.FC = React.memo(() => {
    const videoCards: VideoCard[] = [
        {
            id: 1,
            title: "Game intro (MP4)",
            src: IntroVideo,
            image: IntroPreview,
        },
        {
            id: 2,
            title: "Game process (MP4)",
            src: GameProcess,
            image: GameProcessPreview,
        },
    ];

    const [clickedId, setClickedId] = useState<number | null>(null);
    const [activeVideoId, setActiveVideoId] = useState<number | null>(null);

    const openVideoModal = (id: number) => {
        setActiveVideoId(id);
    };

    const closeVideoModal = () => {
        setActiveVideoId(null);
    };

    const activeVideo = activeVideoId
        ? videoCards.find((v) => v.id === activeVideoId) || null
        : null;

    useEffect(() => {
        if (activeVideoId !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [activeVideoId]);

    return (
        <div className="video-content">
            {videoCards.map((video) => (
                <div className="video-card" key={video.id}>
                    <div
                        className={
                            "video-card-preview " + (clickedId === video.id ? "clicked" : "")
                        }
                        onMouseDown={() => setClickedId(video.id)}
                        onClick={() => openVideoModal(video.id)}
                        onMouseUp={() => setClickedId(null)}
                    >
                        <img
                            src={video.image}
                            alt={video.title}
                            className="video-card-image"
                        />
                        <img src={PlayIcon} alt="Play" className="video-card-play" />
                    </div>
                    <p className="video-card-title">{video.title}</p>
                    <DownloadBtn href={video.src} filename={video.title} />
                </div>
            ))}

            {activeVideo && (
                <div className="video-modal-container" onClick={closeVideoModal}>
                    <div
                        className="video-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="video-modal-header">
                            <p className="video-modal-title">{activeVideo.title}</p>
                            <img src={CrossIcon} alt="close" onClick={closeVideoModal} className="video-modal-close" />
                        </div>

                        <video
                            className="video-modal-player"
                            src={activeVideo.src}
                            controls
                            autoPlay
                        />
                    </div>
                </div>
            )}
        </div>
    );
});